import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";

const FooterDetails = () => {
  const [formData, setFormData] = useState({
    address: "",
    phone: "",
    email: "",
    whatsapp: "",
    facebook: "",
    linkedin: "",
    youtube: "",
    instagram: "",
    pinterest: "",
    other: "",
  });

  // Fetch existing footer details
  const fetchFooterDetails = async () => {
    try {
      const response = await axios.get(`${baseurl}getFooterDetails`);
      if (response.data && response.data.data) {
        setFormData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching footer details:", error);
      Swal.fire("Error", "Failed to load footer details!", "error");
    }
  };

  // Load footer details on component mount
  useEffect(() => {
    fetchFooterDetails();
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission (Update existing record)
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await axios.post(`${baseurl}saveFooterDetails`, formData);
      Swal.fire("Success", "Footer details updated successfully!", "success");
    } catch (error) {
      console.error("Error updating footer details:", error);
      Swal.fire("Error", "Failed to update details. Try again!", "error");
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />

        <div className="container-fluid">
          <h4 className="mb-3 text-start">Footer Details</h4>
          <div className="crd1 mb-3">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                {[
                  { label: "Address", name: "address" },
                  { label: "Phone", name: "phone" },
                  { label: "Email", name: "email" },
                  { label: "WhatsApp", name: "whatsapp" },
                  { label: "Facebook URL", name: "facebook" },
                  { label: "LinkedIn URL", name: "linkedin" },
                  { label: "YouTube URL", name: "youtube" },
                  { label: "Instagram URL", name: "instagram" },
                  { label: "Pinterest URL", name: "pinterest" },
                  { label: "Other Platforms", name: "other" },
                ].map((field, index) => (
                  <div className="col-md-12 d-flex align-items-center" key={index}>
                    <label className="me-2 text-start" style={{ width: "150px" }}>
                      {field.label}:
                    </label>
                    <input
                      type="text"
                      name={field.name}
                      className="form-control"
                      placeholder={`Enter ${field.label}`}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                    />
                  </div>
                ))}

                {/* Submit Button */}
                <div className="col-12 text-end mt-3">
                  <button type="submit" className="btn btn-primary">
                    Update Details
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterDetails;
